import { render, staticRenderFns } from "./@PopupSectionTaskGallery.vue?vue&type=template&id=0790f731&scoped=true&"
import script from "./@PopupSectionTaskGallery.vue?vue&type=script&lang=js&"
export * from "./@PopupSectionTaskGallery.vue?vue&type=script&lang=js&"
import style0 from "./@PopupSectionTaskGallery.vue?vue&type=style&index=0&id=0790f731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0790f731",
  null
  
)

export default component.exports